import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const calcNrCartella = (repartoSelector, nrCartellaSelector) => {
  const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
  const getNrCartellaUrl = `${baseUrl}/guest_statuses/calcola_nr_cartella.json`;
  const selectReparto = document.querySelector(repartoSelector);
  const nrCartellaInput = document.querySelector(nrCartellaSelector);
  const currentYear = new Date().getFullYear();
  selectReparto.onchange = (event) => {
    if (event.currentTarget.value) {
      const repartoId = event.currentTarget.value;
      apiConnector()
        .get(`${getNrCartellaUrl}?business_unit_id=${repartoId}&year=${currentYear}`)
        .then((response) => {
          nrCartellaInput.value = response.data['nr'];
        });
    }
  };
};

const init = (repartoSelector, nrCartellaSelector) => {
  try {
    calcNrCartella(repartoSelector, nrCartellaSelector);
  } catch (e) {
    errorManager(e);
  }
};

window.NrCartella = {
  init: init,
};
